import { AccountsList, HelperWrapper, MainContainer } from 'src/components'

import { ETranslationNs } from 'src/types'

const AccountsScreen = () => {
  return (
    <MainContainer
      headerTitle={<HelperWrapper t="accounts-header-title" ns={ETranslationNs.Navbar} />}
      withScanBtn
    >
      <AccountsList />
    </MainContainer>
  )
}

export default AccountsScreen
